import React, { useState, useEffect, useRef } from "react";

import classes from "./Map.module.css";

import { gsap } from "gsap/src/all";
import { ScrollTrigger } from "gsap/all";
import { useDispatch } from "react-redux";
import { ScrollActions } from "../../store/Slices/ScrollSlice";

import Lebanon from "../../images/LebanonWireframe.png";
import Location from "../../images/svgs/location.svg";
import MapModule from "./MapModule/MapModule";
import Giving from "../Giving/Giving";
import Space from "../UI/Space/Space";

const Map = (props) => {
  const dispatch = useDispatch();

  gsap.registerPlugin(ScrollTrigger);
  let container = useRef(null);
  let loc1 = useRef(null);
  let loc2 = useRef(null);
  let loc3 = useRef(null);
  let loc4 = useRef(null);

  //activate the map button
  //  const selectMap = (event) => {
  //   var items = document.getElementsByClassName(classes.loc);
  //   for (var i = 0; i < items.length; i++) {
  //     items[i].className = classes.loc;
  //   }

  //   event.target.className = classes.loc + " " + classes.active;
  // };

  //active state
  const [active, setActive] = useState(1);
  //location state
  const [location, setLocation] = useState(
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d16633.02108323836!2d35.2981547959449!3d33.432975289547485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDI1JzU4LjciTiAzNcKwMTgnMzIuNyJF!5e0!3m2!1sen!2slb!4v1448974540945"
  );
  //info state
  const [info, setInfo] = useState({
    title: "Nabih Berri Rehabilitation Compound",
    location: "Sarafand - South Lebanon",
    phone: "+9617441010",
    fax: "+9617441010",
    email: "lwah@lwah.org.lb",
  });

  //set Beirut location url and info
  const selectBeirut = () => {
    wiggle2();
    setActive(2)
    setLocation(
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3311.900844799498!2d35.49537631545888!3d33.89220743359347!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDUzJzMxLjkiTiAzNcKwMjknNTEuMiJF!5e0!3m2!1sen!2slb!4v1448975178664"
    );
    setInfo({
      title: "Zoukak El-Blat - Batrakiye St. - Al-Arij Bldg.",
      location: "Sarafand - South Lebanon",
      phone: "+9611374100/1/2",
      fax: "+9611374033",
      email: "lwah@lwah.org.lb",
    });
  };

  //set Sarafand location url and info
  const selectSarafand = () => {
    wiggle1();
    setActive(1)
    setLocation(
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d16633.02108323836!2d35.2981547959449!3d33.432975289547485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDI1JzU4LjciTiAzNcKwMTgnMzIuNyJF!5e0!3m2!1sen!2slb!4v1448974540945"
    );
    setInfo({
      title: "Nabih Berri Rehabilitation Compound",
      location: "Sarafand - South Lebanon",
      phone: "+9617441010",
      fax: "+9617441010",
      email: "lwah@lwah.org.lb",
    });
  };

  //set Bekaa location url and info
  const selectBekaa = () => {
    wiggle4();
    setActive(4)
    setLocation(
      "https://maps.google.com/maps?q=33%C2%B059'32.9%22N%2036%C2%B011'35.3%22E&t=&z=17&ie=UTF8&iwloc=&output=embed"
    );
    setInfo({
      title: "Bekaa Center",
      location: "Baalbeck - Douris - Taadod Street",
      phone: "+9618371512",
      fax: "no fax",
      email: "lwah@lwah.org.lb",
    });
  };
  //set Bekaa location url and info
  const selectTyre = () => {
    wiggle3();
    setActive(3)
    setLocation(
      "https://maps.google.com/maps?q=Bassel%20Al%20Assad%20Center&t=&z=17&ie=UTF8&iwloc=&output=embed"
    );
    setInfo({
      title: "Bassel Al Assad Center",
      location: "To Fill",
      phone: "+9618371512",
      fax: "no fax",
      email: "lwah@lwah.org.lb",
    });
  };

  useEffect(() => {
    gsap.from(loc1.current, {
      yPercent: -1000,
      opacity: 0,
      delay: 1,
      duration: 1,
      ease: "bounce.out",
      scrollTrigger: {
        trigger: loc1.current,
        toggleActions: "restart none restart none",
        end: "bottom bottom",
        // markers:true,
      },
    });
    gsap.from(loc2.current, {
      yPercent: -800,
      opacity: 0,
      delay: 1,
      duration: 1.2,
      ease: "bounce.out",
      scrollTrigger: {
        trigger: loc1.current,
        toggleActions: "restart none restart none",
        end: "bottom bottom",
        // markers:true,
      },
    });
    gsap.from(loc3.current, {
      yPercent: -600,
      opacity: 0,
      delay: 1.25,
      duration: 1,
      ease: "bounce.out",
      scrollTrigger: {
        trigger: loc1.current,
        toggleActions: "restart none restart none",
        end: "bottom bottom",
        // markers:true,
      },
    });
    gsap.from(loc4.current, {
      yPercent: -800,
      opacity: 0,
      delay: 0.9,
      duration: 1.1,
      ease: "bounce.out",
      scrollTrigger: {
        trigger: loc1.current,
        toggleActions: "restart none restart none",
        end: "bottom bottom",
        // markers:true,
      },
    });
    let trigger = ScrollTrigger.create({
      trigger: container.current,
      start: "top bottom",
      end: "bottom bottom",
      scrub: true,
      // markers: true,
      onUpdate: (self) => {
        // console.log("progress", self.progress);
        dispatch(ScrollActions.UpdateMap(self.progress));
      },
    });

    return ()=>{
      trigger.kill();
    }

  }, []);

  const wiggle1 = () => {
    gsap
      .timeline()
      .to(loc1.current, {
        scaleY: 0.5,
        y: 10,
        duration: 0.2,
        ease: "easeOut",
      })
      .to(loc1.current, {
        y: 0,
        scaleY: 1,
        duration: 0.5,
        ease: "elastic",
      });
  };
  const wiggle2 = () => {
    gsap
      .timeline()
      .to(loc2.current, {
        scaleY: 0.5,
        y: 10,
        duration: 0.2,
        ease: "easeOut",
      })
      .to(loc2.current, {
        y: 0,
        scaleY: 1,
        duration: 0.5,
        ease: "elastic",
      });
  };
  const wiggle3 = () => {
    gsap
      .timeline()
      .to(loc3.current, {
        scaleY: 0.5,
        y: 10,
        duration: 0.2,
        ease: "easeOut",
      })
      .to(loc3.current, {
        y: 0,
        scaleY: 1,
        duration: 0.5,
        ease: "elastic",
      });
  };
  const wiggle4 = () => {
    gsap
      .timeline()
      .to(loc4.current, {
        scaleY: 0.5,
        y: 10,
        duration: 0.2,
        ease: "easeOut",
      })
      .to(loc4.current, {
        y: 0,
        scaleY: 1,
        duration: 0.5,
        ease: "elastic",
      });
  };
  return (
    <div className={classes.container + " " + props.className} ref={container}>
      <div>
        <h1>Our Centers</h1>
      </div>
      <div className={classes.row}>
        <div className={classes.column}>
          <div className={classes.box}>
            <img src={Lebanon} alt="lebanonMap" className={classes.lebanon} />
            <img
              src={Location}
              alt="location"
              className={classes.location1}
              ref={loc1}
              onClick={(e) => {
                selectSarafand();
              }}
            />
            <img
              src={Location}
              alt="location"
              className={classes.location2}
              ref={loc2}
              onClick={(e) => {
                selectBeirut();
              }}
            />
            <img
              src={Location}
              alt="location"
              className={classes.location3}
              ref={loc3}
              onClick={(e) => {
                selectTyre();
              }}
            />
            <img
              src={Location}
              alt="location"
              className={classes.location4}
              ref={loc4}
              onClick={(e) => {
                selectBekaa();
              }}
            />
          </div>
        </div>
        <div className={classes.column}>
          <MapModule
            active={active}
            location={location}
            info={info}
            selectSarafand={selectSarafand}
            selectBeirut={selectBeirut}
            selectBekaa={selectBekaa}
            selectTyre={selectTyre}
            wiggle1={wiggle1}
            wiggle2={wiggle2}
            wiggle3={wiggle3}
            wiggle4={wiggle4}
          />
        </div>
      </div>
      <Space height={20} />
      <div className={classes.row + " "}>
        <Giving />
      </div>
    </div>
  );
};
export default Map;
